<template>
  <div class="app-content content">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <a class="brand-logo" href="javascript:void(0);"></a>
            <div class="d-none d-lg-flex col-lg-8 align-items-center">
              <div
                class="
                  w-100
                  d-lg-flex
                  align-items-center
                  justify-content-center
                "
              >
                <img :src="$assets('images/connexion.png')" alt="Login V2" />
              </div>
            </div>
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div
                class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto"
                style="margin-top: -200px"
              >
                <a href="/">
                  <img
                    class="img-fluid ml-2"
                    :src="$assets('images/logo.png')"
                    alt=""
                  />
                </a>
                <form class="mt-3" autocomplete="off">
                  <h4 class="card-title font-weight-bold mb-1">Connexion</h4>
                  <div class="form-group">
                    <label>Téléphone</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i data-feather="phone"></i>
                          <input
                            type="number"
                            style="width: 60px; border-width: 0; height: 20px"
                            class="form-control"
                            v-model="form.indic"
                          />
                        </span>
                      </div>
                      <input
                        v-model="form.username"
                        class="form-control"
                        type="text"
                      />
                    </div>
                    <div v-if="errors.username" style="color: red">
                      {{ errors.username[0] }}
                    </div>
                  </div>
                  <button
                    v-if="!loading"
                    class="btn btn-primary btn-block"
                    @click.prevent="authenticate()"
                  >
                    Se connecter
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form>
                <p class="text-center mt-2">
                  <span>Pas encore inscrit ?</span>
                  <a :href="register()"
                    ><span style="color: #002a85">
                      <u>Créer un compte</u>
                    </span>
                  </a>
                </p>
                <p class="text-center mt-2">
                  <span style="font-size: 12px"
                    >En utilisant cette application, vous acceptez nos
                    <a
                      :href="$assets('terms')"
                      target="_blank"
                      style="color: #002a85"
                      >conditions d'utilisation</a
                    ></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../helpers/shared";

export default {
  name: "login",
  props: {
    route: {
      type: String,
      default: () => "",
    },
  },
  data: () => ({
    form: {
      username: "",
      password: "",
      indic: "228",
    },
    req:{
      phone:'',
      pass:'',
      checked:'',
    },
    router: {},
    loading: false,
    errors: [],
  }),
  methods: {
    authenticate() {
      this.loading = true;
      axios
        .post(api("auth/login"), this.form)
        .then((response) => {
          console.log(response)
          localStorage.setItem('auth', JSON.stringify(response.data))
          this.loading = false;
          this.errors = [];
          if(response.data.status && response.data.mod === 1){//cree son mot de passe
            this.$storage.setItem(
              "key_phone",
              this.$storage.encryptString(this.form.username)
            );
            this.form.username = "";
            this.$router("create-password");
          }else{
            //le mot de passe existe deja
            if (response.data.status) {
              this.$storage.setItem(
                "key_phone",
                this.$storage.encryptString(this.form.username)
              );
              this.form.username = "";
              this.$router("password");
            }
          }

        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },
    register() {
      return this.router.register;
    },
  },
  mounted() {
    this.router = JSON.parse(this.route);
  },
};
</script>

<style scoped>
</style>
